module.exports = __webpack_public_path__ + "img/piikill.5db291ef.jpg";